import { IFormUsecase } from '../../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../../Shared/Protocol/protocol-result'
import { CreativeFlowService } from '../../../Services/HCP/creativeflow/creative-flow.service'
import {
  IHCPArteKanbanColunaPayload,
  IHCPArteKanbanColunaResponse,
} from '../../../Services/HCP/creativeflow/creative-flow.interface'

export class ListHCPArtesColunaUseCase
  implements IFormUsecase<IHCPArteKanbanColunaPayload, IHCPArteKanbanColunaResponse>
{
  constructor(private readonly hcpArtesApi: CreativeFlowService) {}

  public async handle(
    data: IHCPArteKanbanColunaPayload
  ): Promise<Result<IHCPArteKanbanColunaResponse>> {
    try {
      const response = await this.hcpArtesApi.getKanbanColumn(data)

      if (response.isFailure) {
        return response
      }

      const value = response.getValue()
      if (!value) return response

      return Result.ok(value)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
